import { ChatBot } from '@shared/components';
import { useChatBot } from '@shared/hooks';
import { useFetchMe } from '@retail/users/data-access';
import React, { useMemo } from 'react';
import { useConsumerType } from '@retail/sanity/hooks';

interface Props {
  mgAppsBffUrl: string;
  mgAppsBffAudience: string;
}

export const ChatBotWrapper: React.FC<Props> = ({ mgAppsBffUrl, mgAppsBffAudience }) => {
  const { data: user } = useFetchMe({ refetchOnWindowFocus: false });
  const userName = useMemo(() => `${user?.givenName} ${user?.familyName}`, [user]);
  const selectedUserGroup = useConsumerType();

  const { messages, sendMessage, authStatus, sessionStatus } = useChatBot({
    url: mgAppsBffUrl,
    audience: mgAppsBffAudience,
    app: 'mgpris',
    userName,
    userGroup: selectedUserGroup,
  });

  return (
    <ChatBot
      messages={messages}
      sendMessage={sendMessage}
      authStatus={authStatus}
      sessionStatus={sessionStatus}
      variant="square"
    />
  );
};
